import Rx from 'rx';
import angular from 'angular';
import moment from "moment";
import {getPreviousWeekday} from "../app";
import DialogController from "./dialog";
import {activeFilterCount, applyFilters, matchesFilters} from '../charts/boardFilters.js';
import {BO_FILTERS} from '../charts/boardFilterCategories.js';
import {showBoardFilters} from './board-filters-dialog';
import {notAuthorizedMessage} from '../services/not-authorized.js';

export default function MemberBidsOffersCtrl($scope, BidsOffersService, $state, $stateParams, $anchorScroll, $timeout, $mdMedia, $mdDialog, observeOnScope, businessDays) {

  $scope.state = $state;
  $scope.noItems = false;
  $scope.refused = null;   // the backend's message when it won't show this login the board
  $scope.report = $stateParams.report;
  $scope.bidsoffers = {};
  $scope.groupActive = localStorage.groupByBO && JSON.parse(localStorage.groupByBO);
  $scope.bids = 0;
  $scope.offers = 0;
  $scope.yourBids = 0;
  $scope.yourOffers = 0;
  $scope.mdMedia = $mdMedia;
  $scope.meta = BidsOffersService.meta();

  $scope.minDate = new Date(2024, 0, 1); // minimum selectable date - January 1, 2024
  $scope.maxDate = new Date(); // maximum selectable date - current date

  var validDays = [];

  businessDays.subscribe(d => validDays = d);

  $scope.filterDays = function async (date) {

    if (validDays.length < 1) {
      const day = date.getDay();
      return day !== 0 && day !== 6; // Disable if it's Sunday (0) or Saturday (6)
    }

    // Use the valid business days from the server
    const day = moment(date).format('YYYY-MM-DD 00:00:00');
    return validDays.includes(day);
  };

  let dSubscription = observeOnScope($scope, 'meta.reportDate')
    .debounce(100)
    .filter(() => $stateParams.report !== 'current')
    .filter(({newValue}) => newValue)
    .map(({newValue, oldValue}) => ({
      newValue: moment(newValue).format('YYYY-MM-DD'),
      oldValue: moment(oldValue).format('YYYY-MM-DD')
    }))
    .filter(({newValue, oldValue}) => newValue !== oldValue)
    .subscribe(({newValue}) => {
      let r = newValue;

      if (newValue === moment().format('YYYY-MM-DD')) {
        r = 'current';
      } else if (newValue === moment(getPreviousWeekday()).format('YYYY-MM-DD')) {
        r = 'report11';
      }
      $state.go('member.bids-offers', {report: r});
    });

  $scope.$on('$destroy', () => dSubscription.dispose());

  var oldTrades;

  var allBidsOffersShared$ = BidsOffersService.load($scope.report)
      .do(function () {
        $scope.bids = 0;
        $scope.offers = 0;
        $scope.yourBids = 0;
        $scope.yourOffers = 0;
      })
      // A login the backend won't show the board to (no trading access): its message where the
      // board would be. Nothing more comes: the service doesn't call again after a failure.
      .catch(function (err) {
        var message = notAuthorizedMessage(err);
        if (!message) {
          return Rx.Observable.throw(err);
        }
        $scope.$applyAsync(function () {
          $scope.refused = message;
        });
        return Rx.Observable.empty();
      })
      .shareReplay(1);

  var allBidsOffers$ = allBidsOffersShared$
      .flatMap(function (array) {

        var trades = oldTrades ?
            array.filter(function (trade) {
              trade.new = oldTrades.filter(function (oldTrade) {
                return oldTrade.BoID === trade.BoID;
              }).length === 0;
              return trade;
            })
            : array;

        oldTrades = trades;

        return Rx.Observable.from(trades);
      });

  var groupBy$ = $scope.$createObservableFunction('groupBy')
      .do(function (g) {
        localStorage.groupByBO = g; //Save this to local storage
        $scope.compareItems = [];
      })
      .startWith(localStorage.groupByBO && JSON.parse(localStorage.groupByBO))
      .map(function (g) {
        return g === true ? 'BO' : null;
      });

  var boSubscription = groupBy$
      .flatMap(function (field) {
        var boCollection = {};

        return allBidsOffersShared$
            .flatMap(function (array) {
              $scope.noItems = true;
              return Rx.Observable.from(array)
                  .groupBy(function (data) {
                    return data[field];
                  });
            })
            .flatMap(function (obs) {
              return obs
                  .toArray()
                  .do(function () {
                    $scope.noItems = false;
                  })
                  .map(function (bos) {
                    boCollection[obs.key] = boCollection[obs.key] || [];
                    boCollection[obs.key] = bos;

                    return boCollection;
                  });
            });
      })
      .map(objectKeySort)
      .debounce(30)
      .safeApply($scope, function (boCollection) {
        $scope.bidsoffers = boCollection;

        $timeout(function () {
          if ($state.params.id) {
            $anchorScroll('trade' + $state.params.id);
          }
        });

      })
      .subscribe();

  var bidsObservable = allBidsOffers$
      .filter(function (bo) {
        return bo.BO.trim() === "B";
      });

  var offersObservable = allBidsOffers$
      .filter(function (bo) {
        return bo.BO.trim() === "O";
      });

  var bidsSubscription = bidsObservable
      .safeApply($scope, function (bid) {
        $scope.bids++;
      }).subscribe();

  var offersSubscription = offersObservable
      .safeApply($scope, function (offer) {
        $scope.offers++;
      }).subscribe();

  var yourBidsSubscription = bidsObservable
      .filter(function (bid) {
        return bid.MemberID;
      })
      .safeApply($scope, function (bid) {
        $scope.yourBids++;
      }).subscribe();

  var yourOffersSubscription = offersObservable
      .filter(function (offer) {
        return offer.MemberID;
      })
      .safeApply($scope, function (offer) {
        $scope.yourOffers++;
      }).subscribe();

  // Combo: the combo id of the currently selected row (state.params.id), so its sibling parts can be highlighted.
  $scope.isCombo = BidsOffersService.isCombo;
  $scope.selectedCombo = null;

  var selectedComboSubscription = observeOnScope($scope, 'state.params.id')
      .map(function (change) {
        return change.newValue;
      })
      .flatMapLatest(function (id) {
        if (!id) {
          return Rx.Observable.just(null);
        }
        return BidsOffersService.get(id)
            .map(function (bo) {
              return BidsOffersService.isCombo(bo) ? String(bo.Combo) : null;
            })
            .startWith(null);
      })
      .safeApply($scope, function (combo) {
        $scope.selectedCombo = combo;
      })
      .subscribe();

  $scope.isComboSibling = function (bo) {
    return !!$scope.selectedCombo
        && String(bo.Combo) === $scope.selectedCombo
        && bo.BoID != $state.params.id;
  };

  $scope.filterYours = false;

  $scope.toggleFilterYours = function () {
    $scope.filterYours = !$scope.filterYours;
    $scope.compareItems = [];
  };

  $scope.yoursFilter = function (bo) {
    if (!$scope.filterYours) {
      return true;
    }
    return bo.MemberID;
  };

  // Filters (the Filters dialog): they narrow the list on top of Yours.
  $scope.filters = {};
  $scope.filterCount = 0;

  /** Every row on the board (grouped or not, every row is in bidsoffers). */
  function boardRows() {
    return [].concat(...Object.values($scope.bidsoffers || {}));
  }

  function setFilters(selection, source) {
    $scope.filters = selection;
    $scope.filterCount = activeFilterCount(selection);
    $scope.compareItems = [];
    BidsOffersService.logFilters(selection, applyFilters(boardRows().filter($scope.yoursFilter), selection, BO_FILTERS).length, source);
  }

  $scope.openFilters = function (ev) {
    // The dialog offers the board's rows, yours only when that is on.
    showBoardFilters($mdDialog, $mdMedia, ev, {
      rows: boardRows().filter($scope.yoursFilter),
      categories: BO_FILTERS,
      selection: $scope.filters
    }).then(selection => setFilters(selection, 'dialog'), angular.noop);
  };

  $scope.clearFilters = function () {
    setFilters({}, 'clear');
  };

  /** The list's row filter (ng-repeat ... | filter:boardFilter). */
  $scope.boardFilter = function (bo) {
    return matchesFilters(bo, $scope.filters, BO_FILTERS);
  };

  // "Showing N of M": what the list shows, of the whole board.
  $scope.$watchGroup(['filters', 'filterYours', 'bidsoffers'], function () {
    var rows = boardRows();
    $scope.boardCount = rows.length;
    $scope.shownCount = applyFilters(rows.filter($scope.yoursFilter), $scope.filters, BO_FILTERS).length;
  });

  // Compare mode
  $scope.compareMode = false;
  $scope.compareItems = [];

  $scope.toggleCompareMode = function () {
    $scope.compareMode = !$scope.compareMode;
    $scope.compareItems = [];
  };

  $scope.toggleCompareItem = function (bo) {
    var idx = $scope.compareItems.indexOf(bo);
    if (idx > -1) {
      $scope.compareItems.splice(idx, 1);
    } else if ($scope.compareItems.length < 2) {
      $scope.compareItems.push(bo);
      if ($scope.compareItems.length === 2) {
        $scope.openCompareDialog();
      }
    }
  };

  $scope.isCompareSelected = function (bo) {
    return $scope.compareItems.indexOf(bo) > -1;
  };

  $scope.openCompareDialog = function () {
    $scope.compareA = $scope.compareItems[0];
    $scope.compareB = $scope.compareItems[1];

    // Build union of attribute keys
    var keysA = $scope.compareA.attributes ? Object.keys($scope.compareA.attributes) : [];
    var keysB = $scope.compareB.attributes ? Object.keys($scope.compareB.attributes) : [];
    var keySet = {};
    keysA.concat(keysB).forEach(function (k) { keySet[k] = true; });
    $scope.compareAttrKeys = Object.keys(keySet);

    $mdDialog.show({
      controller: ['$scope', '$mdDialog', DialogController],
      template: require('../views/member-bids-offers-compare-dialog.html'),
      parent: angular.element(document.body),
      clickOutsideToClose: true,
      fullscreen: true,
      scope: $scope,
      preserveScope: true,
      onRemoving: function () {
        // stay in compare mode so user can re-select
      }
    });
  };

  $scope.exitCompare = function () {
    $mdDialog.hide();
    $scope.compareMode = false;
    $scope.compareItems = [];
  };

  $scope.closeCompare = function () {
    $mdDialog.hide();
  };

  $scope.fieldsMatch = function (val1, val2) {
    if (val1 === val2) return true;
    if (val1 == null && val2 == null) return true;
    if (val1 == null || val2 == null) return false;
    return String(val1).trim() === String(val2).trim();
  };

  //Column sorting (sorts within groups when grouped, full list when ungrouped)
  $scope.sortField = null;
  $scope.sortReverse = false;
  $scope.sortKey = null;

  var numericSort = function (prop) {
    return function (item) {
      return parseFloat(item[prop]) || 0;
    };
  };

  var numericFields = {
    'Price': numericSort('Price'),
    'Market': numericSort('Market'),
    'Qty': numericSort('Qty')
  };

  $scope.sortBy = function (field) {
    var key = field.toString();
    if ($scope.sortKey === key) {
      if ($scope.sortReverse) {
        $scope.sortField = null;
        $scope.sortReverse = false;
        $scope.sortKey = null;
      } else {
        $scope.sortReverse = true;
      }
    } else {
      if (typeof field === 'string' && numericFields[field]) {
        $scope.sortField = numericFields[field];
      } else if (Array.isArray(field) && field.length > 0 && numericFields[field[0]]) {
        $scope.sortField = numericFields[field[0]];
      } else {
        $scope.sortField = field;
      }
      $scope.sortReverse = false;
      $scope.sortKey = key;
    }
  };

  $scope.splitBO = function (array, value) {
    return array.filter(function (item) {
      return item.BO === value;
    });
  };

  $scope.doRefresh = function () {
    BidsOffersService.load($scope.report);
  };

  $scope.$on('$destroy', function () {
    boSubscription.dispose();
    bidsSubscription.dispose();
    offersSubscription.dispose();
    yourBidsSubscription.dispose();
    yourOffersSubscription.dispose();
    selectedComboSubscription.dispose();
  });

  $scope.hasDisplayValue = function(attr) {
    if (!attr) {return false;}
    if (!attr.value) {return false;}
    switch (attr.type) {
      case 'boolean':     return attr.value === true || attr.value === false;
      case 'multiselect': return Array.isArray(attr.value) && attr.value.length > 0;
      default:            return attr.value !== null && attr.value !== undefined && attr.value !== '';
    }
  };

  $scope.displayValue = function(attr) {
    if (!attr) {return '';}
    switch (attr.type) {
      case 'boolean':     return attr.value ? 'Yes' : 'No';
      case 'multiselect': return (attr.value || []).join(', ') + (attr.unit ? ` ${attr.unit}` : '');
      default:            return attr.value + (attr.unit ? ` ${attr.unit}` : '');
    }
  };

  $scope.displayAbbreviation= function(attr) {
    if (!attr) {return '';}
    switch (attr.type) {
      case 'select':     return attr.value || attr.abbreviation;
      default:           return attr.abbreviation;
    }
  };

}

function objectKeySort(collection) {
  var collectionKeys = [], sortedCollection = {};
  for (var itemKey in collection) {
    if (hasOwnProperty.call(collection, itemKey) && itemKey.charAt(0) !== '$') {
      collectionKeys.push(itemKey);
    }
  }
  collectionKeys.sort();

  collectionKeys.forEach(function (k) {
    sortedCollection[k] = collection[k];
  });

  return sortedCollection;
}
